<template>
  <section class="hero is-fullheight">
    <div class="hero-background"></div>
    <div class="hero-content">
      <div class="login-box">
        <div class="notification">
          <p>Gelieve het wachtwoord van het geboortekaartje in te vullen om verder te gaan.</p>
          <div class="field is-grouped" style="margin-top: 0.5rem;">
            <p class="control is-expanded">
              <input
                class="input"
                type="text"
                v-on:keyup.enter="$root.$emit('login', password)"
                v-model="password"
                placeholder="Geef wachtwoord in en druk op OK"
              >
            </p>
            <p class="control">
              <button class="button is-primary" @click="$root.$emit('login', password)">
                OK
              </button>
            </p>
          </div>
          <div v-if="error" class="has-text-danger">
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Login',
  props: {
    error: String,
  },
  data() {
    return {
      password: null,
    };
  },
};
</script>

<style scoped>
.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-image: url('../assets/card_front.png');
  background-size: cover;
  background-position: center;
}

.hero-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  min-height: 100vh;
  padding: 2rem;
}

.login-box {
  background-color: rgba(255, 255, 255, 0.8);
    padding: 1.5rem;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin-top: 300px;
    margin-right: 10%;
}

.notification {
  background-color: transparent;
  padding: 0;
}

.input, .button {
  border-radius: 20px;
}

@media screen and (max-width: 768px) {
  .hero-background {
    background-image: url('../assets/card_front_mobile.png');
  }

  .hero-content {
    align-items: center;
    justify-content: center;
    padding: 1rem;
  }

  .login-box {
    width: 95%;
    margin: 0 auto;
    margin-top: 10vh;
  }
}
</style>
